module.exports = __webpack_public_path__ + "static/media/delete.48f1ed9c.svg";